import { App } from 'vue';
// import { ElMessage, ElMessageBox } from 'element-plus';
// import ElementPlus from 'element-plus';
// import 'element-plus/dist/index.css';
// import 'src/styles/theme/index_element_ui.css';
import 'src/plugins/element-plus/redefine.css';

export function useElement(_app: App) {
    _app.config.globalProperties.$message = ElMessage;
    _app.config.globalProperties.$msgbox = ElMessageBox;
    _app.config.globalProperties.$alert = ElMessageBox.alert;
    _app.config.globalProperties.$confirm = ElMessageBox.confirm;
    _app.config.globalProperties.$prompt = ElMessageBox.prompt;
    // 按需引入由于 unplugin-vue-components 组件会导致sourcemap错位，暂时停用，改用完整引入
    // _app.use(ElementPlus);
}
